var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDotsIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.502 0C1.79907 0 2.08947 0.0859116 2.33647 0.246871C2.58347 0.40783 2.77599 0.636607 2.88967 0.904272C3.00336 1.17194 3.0331 1.46647 2.97514 1.75062C2.91719 2.03477 2.77414 2.29578 2.56408 2.50064C2.35402 2.70551 2.08639 2.84502 1.79503 2.90154C1.50367 2.95806 1.20167 2.92905 0.927211 2.81818C0.652756 2.70731 0.418175 2.51956 0.253133 2.27867C0.0880909 2.03778 0 1.75456 0 1.46484C0 1.07634 0.158246 0.703754 0.439926 0.429043C0.721607 0.154331 1.10365 0 1.502 0ZM1.502 9.0752C1.79907 9.0752 2.08947 9.16111 2.33647 9.32207C2.58347 9.48302 2.77599 9.7118 2.88967 9.97947C3.00336 10.2471 3.0331 10.5417 2.97514 10.8258C2.91719 11.11 2.77414 11.371 2.56408 11.5758C2.35402 11.7807 2.08639 11.9202 1.79503 11.9767C1.50367 12.0333 1.20167 12.0042 0.927211 11.8934C0.652756 11.7825 0.418175 11.5948 0.253133 11.3539C0.0880909 11.113 0 10.8298 0 10.54C0 10.1515 0.158246 9.77895 0.439926 9.50424C0.721607 9.22953 1.10365 9.0752 1.502 9.0752ZM1.502 4.53711C1.79907 4.53711 2.08947 4.62302 2.33647 4.78398C2.58347 4.94494 2.77599 5.17372 2.88967 5.44138C3.00336 5.70905 3.0331 6.00358 2.97514 6.28773C2.91719 6.57188 2.77414 6.83289 2.56408 7.03775C2.35402 7.24262 2.08639 7.38213 1.79503 7.43865C1.50367 7.49517 1.20167 7.46616 0.927211 7.35529C0.652756 7.24442 0.418175 7.05667 0.253133 6.81578C0.0880909 6.57488 0 6.29167 0 6.00195C0 5.61345 0.158246 5.24086 0.439926 4.96615C0.721607 4.69144 1.10365 4.53711 1.502 4.53711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotsIcon3);
export default __webpack_public_path__ + "static/media/vertical-dots-icon-3.1a4261d98c5821cad56e1f3abf80222f.svg";
export { ForwardRef as ReactComponent };